/* tslint:disable */
import {
  CompanyAccount,
  PropertyUnits,
  Lease,
  IncomeInvoice,
  MeterReadingEntry
} from '../index';

declare var Object: any;
export interface MeterReadingInterface {
  "previous_value"?: number;
  "current_value": number;
  "property_unit_id": number;
  "meter_reading_entry_id": number;
  "property_id": number;
  "invoice_id"?: number;
  "lease_id"?: number;
  "read_type"?: string;
  "current"?: boolean;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  property?: CompanyAccount;
  propertyUnit?: PropertyUnits;
  lease?: Lease;
  incomeInvoice?: IncomeInvoice;
  meterReadingEntry?: MeterReadingEntry;
}

export class MeterReading implements MeterReadingInterface {
  "previous_value": number;
  "current_value": number;
  "property_unit_id": number;
  "meter_reading_entry_id": number;
  "property_id": number;
  "invoice_id": number;
  "lease_id": number;
  "read_type": string;
  "current": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  property: CompanyAccount;
  propertyUnit: PropertyUnits;
  lease: Lease;
  incomeInvoice: IncomeInvoice;
  meterReadingEntry: MeterReadingEntry;
  constructor(data?: MeterReadingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MeterReading`.
   */
  public static getModelName() {
    return "MeterReading";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MeterReading for dynamic purposes.
  **/
  public static factory(data: MeterReadingInterface): MeterReading{
    return new MeterReading(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MeterReading',
      plural: 'MeterReadings',
      path: 'MeterReadings',
      idName: 'id',
      properties: {
        "previous_value": {
          name: 'previous_value',
          type: 'number'
        },
        "current_value": {
          name: 'current_value',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "meter_reading_entry_id": {
          name: 'meter_reading_entry_id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "invoice_id": {
          name: 'invoice_id',
          type: 'number',
          default: 0
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number',
          default: 0
        },
        "read_type": {
          name: 'read_type',
          type: 'string',
          default: 'NORMAL'
        },
        "current": {
          name: 'current',
          type: 'boolean',
          default: true
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        propertyUnit: {
          name: 'propertyUnit',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
        incomeInvoice: {
          name: 'incomeInvoice',
          type: 'IncomeInvoice',
          model: 'IncomeInvoice',
          relationType: 'belongsTo',
                  keyFrom: 'invoice_id',
          keyTo: 'id'
        },
        meterReadingEntry: {
          name: 'meterReadingEntry',
          type: 'MeterReadingEntry',
          model: 'MeterReadingEntry',
          relationType: 'belongsTo',
                  keyFrom: 'meter_reading_entry_id',
          keyTo: 'id'
        },
      }
    }
  }
}
